









import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconPlus extends Vue {
    @Prop({ type: Number, default: 22 }) readonly size!: number
    @Prop({type: Boolean, default: false}) readonly inCircle!: boolean

    get componentClasses(): object {
        return {
            'kv-icon-plus': true,
            'background': this.inCircle,
        }
    }
}
